import { render, staticRenderFns } from "./_itemSlug.vue?vue&type=template&id=6bed67d2&"
import script from "./_itemSlug.vue?vue&type=script&lang=js&"
export * from "./_itemSlug.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports